// extracted by mini-css-extract-plugin
export default {"black":"#000","primary":"#49aada","orange":"#eb9412","root":"xfIw9FG3TfaXqB3EfLTH","icon":"Rv5lmFJAFZ7BruSm7QEA","label":"mY_XTtBHOWLDmT9lbLbg","input":"UESorQxJw1n0A8Yi6rMr"};